import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={22.973}
    height="6.9mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 13886 15763"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#2b2a29;stroke-width:228.444}.fil0{fill:#000}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974339078112">
        <path
          d="M3600 6808c0-470 144-1015 291-1343 179-398 385-696 681-990 1699-1689 4382-1164 5395 941 436 905 400 1986-48 2882-366 730-768 901-1179 1581-119 198-214 412-294 650-325 977-12 1617-270 1617H5634c0-3099-1453-2584-1925-4538-50-203-109-554-109-800zm-799 0c0 1141 509 2208 1299 2987 331 326 624 882 693 1449 60 500-12 1366 105 1529 81 113 189 172 373 172h3340c176 0 273-51 357-152 109-132 82-242 79-465l41-1049c166-1576 1356-1492 1867-3506 696-2740-1699-5651-4920-4993-1268 259-2323 1183-2859 2334-105 225-206 514-257 759-53 250-118 659-118 935zM4871 13889c0 211 75 436 363 436h3414c483 0 523-799-73-799H5307c-235 0-436 136-436 363zM5525 15196c0 305 230 436 544 436 436 0 1896 74 2123-93 305-225 144-706-198-706H5888c-186 0-363 191-363 363zM6541 490v1126c0 517 799 517 799 0V490c0-501-799-501-799 0zM9228 2269c0 573 530 500 692 292 120-154 659-1038 639-1224-34-330-482-556-735-178-112 167-596 961-596 1110zM114 6917c0 568 636 436 1344 436 785 0 611-799 181-799H477c-204 0-363 159-363 363zM11879 6917c0 569 743 436 1416 436 661 0 574-799 109-799h-1161c-183 0-364 181-364 363zM4181 2705c867 0 332-768 107-1160-131-230-290-583-543-583-263 0-548 273-362 616 41 76 98 170 146 254 114 197 441 873 652 873zM986 10113c0 811 804 269 1150 61 220-132 593-257 593-570 0-210-217-399-436-399-89 0-899 474-1061 573-122 75-246 151-246 335zM11153 9604c0 143 98 275 201 344 215 144 992 600 1179 600 375 0 537-504 139-756-162-103-992-587-1083-587-220 0-436 189-436 399zM2293 4666c125 0 245-44 317-118 369-378-183-669-460-828-193-110-592-397-801-397-268 0-665 446-81 807l741 420c90 56 149 116 284 116zM11153 4267c0 191 161 399 436 399 92 0 1307-613 1307-835 0-245-50-508-399-508-147 0-601 301-742 384-203 119-602 280-602 560z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
